(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('DownloadNContractPDFController',DownloadNContractPDFController);

    DownloadNContractPDFController.$inject = ['$uibModalInstance', 'invoiceNum', 'forSale'];

    function DownloadNContractPDFController($uibModalInstance, invoiceNum, forSale) {
        var vm = this;

        vm.forSale = forSale;

        vm.showStuff = ["Show", "Hide"];

        vm.formElement = {
            header: 1,
            showVessel: "Hide",
            showVoyageDetails: "Hide",
            showLotWeights: 'Hide',
            showContract: "Hide",
            showLot: "Hide",
            showLCDetails: "Hide",
            showController: "Hide",
            showPaymentTenor: "Hide"
        };

        vm.currentHeader = "";

        vm.headerOptions = [
            "TOYOSHIMA INTERNATIONAL AMERICA, INC.<br/>19600 MAGELLAN DRIVE<br/>TORRANCE CA 90502 USA<br/>Tel: 310-879-4450<br/>Fax: 310-879-4451",
            "TOYOSHIMA & CO., LTD.<br/>15-15, NISHIKI 2-CHOME,<br/>NAKAKU, NAGOYA, 460-8671 JAPAN<br/>Tel: 81-52-204-7502<br/>Fax: 81-52-204-7423"
        ];

        vm.headerOptionsJapan = [
            "TOYOSHIMA & CO, LTD.<br/>15-15 NISHIKI 2-CHOME, NAKA-KU,<br/>NAGOYA<br/>460-8671<br/>JAPAN",
            "TOYOSHIMA INTERNATIONAL AMERICA, INC.<br/>19600 MAGELLAN DRIVE<br/>TORRANCE CA 90502 USA<br/>Tel: 310-879-4450<br/>Fax: 310-879-4451"
        ];

        applyHeader();

        vm.clear = clear;
        vm.submit = submit;
        vm.updateHeader = updateHeader;
        vm.updateShowVessel = updateShowVessel;
        vm.updateShowVoyageDetails = updateShowVoyageDetails;
        vm.updateShowLotWeights = updateShowLotWeights;
        vm.updateShowContract = updateShowContract;
        vm.updateShowLot = updateShowLot;
        vm.updateShowLCDetails = updateShowLCDetails;
        vm.updateShowController = updateShowController;
        vm.updateShowPaymentTenor = updateShowPaymentTenor;
        vm.updateAll = updateAll;
        vm.endChecker = endChecker;

        function updateHeader(option) {
            vm.formElement.header = option;
            applyHeader();
        }

        function applyHeader() {
            vm.currentHeader = returnHeader(vm.formElement.header);
        }

        function returnHeader(option) {
            if(vm.forSale || (!vm.forSale && endChecker())) { //normal
                return vm.headerOptions[option - 1];
            } else if(!vm.forSale && !endChecker()) { //japan
                return vm.headerOptionsJapan[option - 1];
            } else {
                return vm.headerOptions[option - 1];
            }
        }

        function updateShowVessel( status ) {
            vm.formElement.showVessel = status;
        }

        function updateShowVoyageDetails( status ) {
            vm.formElement.showVoyageDetails = status;
        }

        function updateShowLotWeights( status ) {
            vm.formElement.showLotWeights = status;
        }

        function updateShowContract( status ) {
            vm.formElement.showContract = status;
        }

        function updateShowLot( status ) {
            vm.formElement.showLot = status;
        }

        function updateShowLCDetails( status ) {
            vm.formElement.showLCDetails = status;
        }

        function updateShowController( status ) {
            vm.formElement.showController = status;
        }

        function updateShowPaymentTenor( status ) {
            vm.formElement.showPaymentTenor = status;
        }

        function updateAll( status ) {
            vm.formElement.showVessel = status;
            vm.formElement.showVoyageDetails = status;
            vm.formElement.showLotWeights = status;
            vm.formElement.showContract = status;
            vm.formElement.showLot = status;
            vm.formElement.showLCDetails = status;
            vm.formElement.showController = status;
            vm.formElement.showPaymentTenor = status;
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function submit() {
            $uibModalInstance.close( vm.formElement );
        }

        function endChecker() {
            //return true if invoice number ends with I
            return invoiceNum.toUpperCase().slice(-1) === "I";
        }
    }
})();
